export const FilterStuffModel = {
    fieldKey: '',
    fieldName: '',
    fieldValue: '',
    fieldType: '',
    fieldGroupValues: [],
    fieldMoney: { min: null, max: null },
    fieldDate: { disableFrom: false },
    fieldTitle: ''
}
